(function () {
    'use strict';

    angular
        .module('riskEventEditModule', [
            'services.authenticatedUser',
            'governanceProcessModule',
            'services.historyCtxt',
            'riskEventModule',
            'boxTemplateModule'
        ]);
})();
